<template>
  <div class="tertiary-list">
    <max-width-container>
      <nav-accordion v-if="links">
        <nav-collapsible
          v-for="(link, index) in links"
          :key="index"
          :is-open="link.active || !isMobile"
          variant="tertiary"
          class="tertiary-list__item"
          data-track-as="nav-collapsible"
          :data-track-text="link.title"
        >
          <template #action="slotProps">
            <list-title
              :title-label="link.title"
              :active="link.active"
              :link-href="link.href"
              :open="slotProps.open"
              :tabbable="!!secondaryOpen"
              :linked="link.href && (!isMobile || !link.sublinks)"
              has-toggle
              @trigger="slotProps.toggle"
            />
          </template>
          <template #content>
            <div class="tertiary-list__content">
              <a
                v-for="(sublink, subindex) in link.sublinks"
                :key="subindex"
                :tabindex="secondaryOpen && !isMobile ? 0 : -1"
                :href="sublink.href"
                :class="{ 'tertiary-list__link--active': sublink.active }"
                class="tertiary-list__link"
              >
                {{ sublink.title }}
              </a>
            </div>
          </template>
        </nav-collapsible>
      </nav-accordion>
    </max-width-container>
  </div>
</template>

<script>
import MaxWidthContainer from '../common/MaxWidthContainer'
import ListTitle from './ListTitle'
import NavAccordion from './NavAccordion'
import NavCollapsible from './NavCollapsible'

export default {
  name: 'TertiaryList',

  components: {
    ListTitle,
    MaxWidthContainer,
    NavAccordion,
    NavCollapsible,
  },

  props: {
    links: {
      type: Array,
      required: true,
    },
    secondaryOpen: Boolean,
  },

  computed: {
    isMobile() {
      return !this.$mq['lg!']
    },
  },
}
</script>

<style lang="postcss" scoped>
.tertiary-list {
  min-height: fit-content;
  max-height: calc(100vh - var(--navigation-height));
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  & >>> .max-width-container {
    height: auto;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  &__item:last-child {
    border-bottom: none;
  }

  &__link {
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    padding: var(--spacing-4) 0;
    border-bottom: 1px solid var(--c-secondary-neutral-3);
    color: var(--c-primary-neutral-1);

    &:hover,
    &:focus {
      color: var(--c-primary-color-2);
    }
  }

  &__link--active {
    color: var(--c-primary-color-2);
  }

  &__link:last-child {
    border-bottom: none;
    padding-bottom: var(--spacing-8);
  }

  &__content {
    display: flex;
    flex-direction: column;
  }

  &__content {
    border-top: 1px solid var(--c-secondary-neutral-3);
  }
}

@media (--lg) {
  .tertiary-list {
    padding: 52px var(--body-offset-horizontal) var(--spacing-16);
    background-color: var(--c-primary-neutral-3);
    border-top: 1px solid var(--c-secondary-neutral-3);

    &__item {
      display: inline-block;
      flex: 0 0 250px;
      border-bottom: none;
      border-top: 1px solid var(--c-secondary-neutral-3);
    }

    &__link:last-child {
      border-bottom: 1px solid var(--c-secondary-neutral-3);
      padding-bottom: var(--spacing-4);
    }
  }
}
</style>
